/*
 * Tencent is pleased to support the open source community by making
 * 蓝鲸智云PaaS平台 (BlueKing PaaS) available.
 *
 * Copyright (C) 2021 THL A29 Limited, a Tencent company.  All rights reserved.
 *
 * 蓝鲸智云PaaS平台 (BlueKing PaaS) is licensed under the MIT License.
 *
 * License for 蓝鲸智云PaaS平台 (BlueKing PaaS):
 *
 * ---------------------------------------------------
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated
 * documentation files (the "Software"), to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and
 * to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of
 * the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO
 * THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF
 * CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 */

import { h } from 'vue';

import { commonSVGProps } from '../common/icon';
export const CloseCircleIcon = h(
  'svg',
  {
    ...commonSVGProps,
    class: {
      [commonSVGProps.class]: true,
      'ai-close-circle-icon': true,
    },
  },
  [
    h('path', {
      d: 'M512 70.246391c230.929037 0 418.133279 187.204242 418.133279 418.133279s-187.204242 418.133279-418.133279 418.133279-418.133279-187.204242-418.133279-418.133279 187.204242-418.133279 418.133279-418.133279z m0 59.733325c-197.938508 0-358.399953 160.461446-358.399953 358.399954s160.461446 358.399953 358.399953 358.399953 358.399953-160.461446 358.399953-358.399953-160.461446-358.399953-358.399953-358.399954z m0 123.199984c129.884516 0 235.199969 105.315453 235.199969 235.19997s-105.315453 235.199969-235.199969 235.199969-235.199969-105.315453-235.199969-235.199969 105.315453-235.199969 235.199969-235.19997z m71.276791 140.165182l-71.283324 71.282391-71.276791-71.275858-23.751464 23.751464 71.275858 71.276791-71.275858 71.27679 23.769197 23.769197 71.276791-71.27679 71.265591 71.26559 23.751463-23.751463-71.264657-71.265591 71.282391-71.283324-23.769197-23.769197z',
    }),
  ],
);
export const DocLinkIcon = h(
  'svg',
  {
    ...commonSVGProps,
    class: {
      [commonSVGProps.class]: true,
      'ai-doc-link-icon': true,
    },
  },
  [
    h('path', {
      d: 'M320.950857 203.337143H191.634286a32.036571 32.036571 0 0 0-31.670857 31.890286v639.561142c0 17.408 14.409143 31.890286 31.670857 31.890286h129.316571a32.036571 32.036571 0 0 0 31.670857-31.890286V235.227429a32.036571 32.036571 0 0 0-31.670857-31.890286z m-35.84 130.486857H227.474286a28.964571 28.964571 0 0 1 0-58.002286h57.490285a28.964571 28.964571 0 0 1 0 58.002286z m293.156572-237.860571H448.877714a32.036571 32.036571 0 0 0-31.597714 31.963428v746.788572c0 17.481143 14.409143 31.963429 31.597714 31.963428h129.462857a32.036571 32.036571 0 0 0 31.524572-31.890286V127.926857c1.462857-17.408-12.873143-31.890286-31.597714-31.890286z m-34.523429 132.022857h-57.490286a28.964571 28.964571 0 0 1 0-58.002286h57.490286a28.964571 28.964571 0 0 1 0 58.002286z m383.780571 613.449143l-120.685714-628.004572a33.792 33.792 0 0 0-33.060571-26.038857H768l-126.537143 24.649143a32.768 32.768 0 0 0-25.819428 37.668571l122.148571 629.394286c2.925714 15.945143 15.872 26.112 31.670857 26.112h5.705143l126.537143-24.649143a35.108571 35.108571 0 0 0 25.819428-39.131428z m-165.302857-529.334858l-57.490285 11.556572h-5.705143a30.72 30.72 0 0 1-28.745143-23.186286 29.696 29.696 0 0 1 22.966857-34.816l57.490286-11.556571c15.798857-2.925714 31.670857 7.241143 34.523428 23.186285a29.696 29.696 0 0 1-22.966857 34.816z',
    }),
  ],
);
export const DeleteCircleIcon = h(
  'svg',
  {
    ...commonSVGProps,
    class: {
      [commonSVGProps.class]: true,
      'ai-delete-circle-icon': true,
    },
  },
  [
    h('path', {
      d: 'M512 64C264 64 64 264 64 512s200 448 448 448 448-200 448-448S760 64 512 64z m180.8 584l-44.8 44.8-136-136-136 136-44.8-44.8 136-136-136-136 44.8-44.8 136 136 136-136 44.8 44.8-136 136 136 136z',
    }),
  ],
);
export const FileUploadIcon = h(
  'svg',
  {
    ...commonSVGProps,
    class: {
      [commonSVGProps.class]: true,
      'ai-delete-circle-icon': true,
    },
  },
  [
    h('path', {
      d: 'M470.8352 362.7008l-192.8192 186.368a160.768 160.768 0 0 0 0.0512 232.8576c66.4576 64.2048 174.4384 64.3072 240.896 0.0512l241.0496-233.0112a34.9184 34.9184 0 0 1 48.1792 0c13.312 12.8512 13.312 33.7408 0 46.592l-241.0496 233.0112c-93.0816 89.9584-244.224 89.856-337.2544-0.0512a225.1264 225.1264 0 0 1-0.0512-326.0416l337.408-326.144a174.1824 174.1824 0 0 1 240.896 0 160.512 160.512 0 0 1 0 232.96l-192.8192 186.368-144.384 139.5712a104.6528 104.6528 0 0 1-144.6912 0.1024 96.1536 96.1536 0 0 1 0.1536-139.8784l337.0496-325.7856a34.9184 34.9184 0 0 1 48.128 0c13.312 12.8512 13.312 33.7408 0 46.592L374.6304 642.048a31.8464 31.8464 0 0 0-0.1536 46.7456 34.816 34.816 0 0 0 48.3328-0.1536l144.384-139.52 192.8192-186.4192a96.1536 96.1536 0 0 0 0-139.776 103.68 103.68 0 0 0-72.2944-29.0304c-27.136 0-53.1456 10.4448-72.2432 29.0304l-144.5888 139.776z',
    }),
  ],
);
